import * as React from 'react';
import { styled } from '@mui/system';
import { fastMemo } from '@mui/x-internals/fastMemo';
import { useGridSelector } from "../../hooks/utils/useGridSelector.js";
import { useGridApiContext } from "../../hooks/utils/useGridApiContext.js";
import { gridDimensionsSelector } from "../../hooks/features/dimensions/index.js";
import { gridClasses } from "../../constants/index.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Filler = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    width: 'var(--DataGrid-rowWidth)',
    boxSizing: 'border-box'
});
var Pinned = styled('div')({
    position: 'sticky',
    height: '100%',
    boxSizing: 'border-box',
    borderTop: '1px solid var(--rowBorderColor)',
    backgroundColor: 'var(--DataGrid-pinnedBackground)'
});
var PinnedLeft = styled(Pinned)({
    left: 0,
    borderRight: '1px solid var(--rowBorderColor)'
});
var PinnedRight = styled(Pinned)({
    right: 0,
    borderLeft: '1px solid var(--rowBorderColor)'
});
var Main = styled('div')({
    flexGrow: 1,
    borderTop: '1px solid var(--rowBorderColor)'
});
function GridVirtualScrollerFiller(param) {
    var rowsLength = param.rowsLength;
    var apiRef = useGridApiContext();
    var _useGridSelector = useGridSelector(apiRef, gridDimensionsSelector), viewportOuterSize = _useGridSelector.viewportOuterSize, minimumSize = _useGridSelector.minimumSize, hasScrollX = _useGridSelector.hasScrollX, hasScrollY = _useGridSelector.hasScrollY, scrollbarSize = _useGridSelector.scrollbarSize, leftPinnedWidth = _useGridSelector.leftPinnedWidth, rightPinnedWidth = _useGridSelector.rightPinnedWidth;
    var height = hasScrollX ? scrollbarSize : 0;
    var needsLastRowBorder = viewportOuterSize.height - minimumSize.height > 0;
    if (height === 0 && !needsLastRowBorder) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Filler, {
        className: gridClasses.filler,
        role: "presentation",
        style: {
            height: height,
            '--rowBorderColor': rowsLength === 0 ? 'transparent' : 'var(--DataGrid-rowBorderColor)'
        },
        children: [
            leftPinnedWidth > 0 && /*#__PURE__*/ _jsx(PinnedLeft, {
                className: gridClasses['filler--pinnedLeft'],
                style: {
                    width: leftPinnedWidth
                }
            }),
            /*#__PURE__*/ _jsx(Main, {}),
            rightPinnedWidth > 0 && /*#__PURE__*/ _jsx(PinnedRight, {
                className: gridClasses['filler--pinnedRight'],
                style: {
                    width: rightPinnedWidth + (hasScrollY ? scrollbarSize : 0)
                }
            })
        ]
    });
}
var Memoized = fastMemo(GridVirtualScrollerFiller);
export { Memoized as GridVirtualScrollerFiller };
